import {
    Button,
    ButtonProps,
} from 'src/components/design-system/form/buttons/Button';
import { FC, ReactElement } from 'react';
import classNames from 'classnames';
import './module.scss';

export type SecondaryButtonProps = ButtonProps;

export const SecondaryButton: FC<SecondaryButtonProps> = (
    props: SecondaryButtonProps
): ReactElement => {
    return (
        <Button
            {...props}
            className={classNames(props.className, 'default-button')}
            _internal={{
                loadingRingColor: '#eb4247',
            }}
        />
    );
};
